<template>
  <el-dialog title="Измение владельца" :visible="visible" v-on="$listeners" @close="onClose">
    <el-form id="formServer" label-position="right" label-width="150px">
      <el-form-item label="Владелец">
        <select-client :owner-id="idAccount" @change="(client) => (this.idAccount = client.id_account)" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="onClose">Отменить</el-button>
      <el-button id="submitServer" :loading="requestLoading" type="primary" @click="onSave">Сохранить</el-button>
    </span>
  </el-dialog>
</template>

<script>
import SelectClient from "@/core/components/features/SelectClient";
import camerasDialogsMixin from "@/components/Cameras/components/dialogs/camerasDialogsMixin";
import { ApiService } from "@/api";

export default {
  name: "CamerasOwnerDialog",
  components: { SelectClient },
  mixins: [camerasDialogsMixin],
  data() {
    return {
      idAccount: null,
    };
  },
  methods: {
    onSave() {
      this.save(() => ApiService.cameras.updateCamerasOwner(this.idAccount, this.cameras));
    },
  },
};
</script>
